import { CurrencyInfo } from '../types';

// Currencies supported by ECB
export const CURRENCIES: Record<string, CurrencyInfo> = {
  AUD: { code: 'AUD', symbol: 'A$', flag: '🇦🇺' },
  BRL: { code: 'BRL', symbol: 'R$', flag: '🇧🇷' },
  CAD: { code: 'CAD', symbol: 'C$', flag: '🇨🇦' },
  CHF: { code: 'CHF', symbol: 'CHF', flag: '🇨🇭' },
  CNY: { code: 'CNY', symbol: '¥', flag: '🇨🇳' },
  CZK: { code: 'CZK', symbol: 'Kč', flag: '🇨🇿' },
  DKK: { code: 'DKK', symbol: 'kr', flag: '🇩🇰' },
  EUR: { code: 'EUR', symbol: '€', flag: '🇪🇺' },
  GBP: { code: 'GBP', symbol: '£', flag: '🇬🇧' },
  HKD: { code: 'HKD', symbol: 'HK$', flag: '🇭🇰' },
  HUF: { code: 'HUF', symbol: 'Ft', flag: '🇭🇺' },
  IDR: { code: 'IDR', symbol: 'Rp', flag: '🇮🇩' },
  ILS: { code: 'ILS', symbol: '₪', flag: '🇮🇱' },
  INR: { code: 'INR', symbol: '₹', flag: '🇮🇳' },
  ISK: { code: 'ISK', symbol: 'kr', flag: '🇮🇸' },
  JPY: { code: 'JPY', symbol: '¥', flag: '🇯🇵' },
  KRW: { code: 'KRW', symbol: '₩', flag: '🇰🇷' },
  MXN: { code: 'MXN', symbol: '$', flag: '🇲🇽' },
  MYR: { code: 'MYR', symbol: 'RM', flag: '🇲🇾' },
  NOK: { code: 'NOK', symbol: 'kr', flag: '🇳🇴' },
  NZD: { code: 'NZD', symbol: 'NZ$', flag: '🇳🇿' },
  PHP: { code: 'PHP', symbol: '₱', flag: '🇵🇭' },
  PLN: { code: 'PLN', symbol: 'zł', flag: '🇵🇱' },
  RON: { code: 'RON', symbol: 'lei', flag: '🇷🇴' },
  SEK: { code: 'SEK', symbol: 'kr', flag: '🇸🇪' },
  SGD: { code: 'SGD', symbol: 'S$', flag: '🇸🇬' },
  THB: { code: 'THB', symbol: '฿', flag: '🇹🇭' },
  TRY: { code: 'TRY', symbol: '₺', flag: '🇹🇷' },
  USD: { code: 'USD', symbol: '$', flag: '🇺🇸' },
  ZAR: { code: 'ZAR', symbol: 'R', flag: '🇿🇦' }
};

export const CURRENCY_LIST = Object.values(CURRENCIES);

export const getCurrencyDisplay = (currencyCode: string): string => {
  const currency = CURRENCIES[currencyCode];
  return currency ? `${currency.flag} ${currency.code}` : currencyCode;
};

export const getCurrencySymbol = (currencyCode: string): string => {
  return CURRENCIES[currencyCode]?.symbol || currencyCode;
};
